import { Link } from "react-router-dom";
import { Facebook, Instagram, Youtube } from "lucide-react";
import { SiteShare } from "@/components/SiteShare";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v13.4a2.59 2.59 0 1 1-2.59-2.59c.27 0 .53.04.78.11v-3.15a5.73 5.73 0 0 0-.78-.05A5.74 5.74 0 1 0 15.6 16.4V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3a4.28 4.28 0 0 1-3.3-1.48Z" />
  </svg>
);

const SOCIALS = [
  { label: "Instagram", href: "https://www.instagram.com/NursingMoma", Icon: Instagram },
  { label: "Facebook", href: "https://www.facebook.com/107670578864885", Icon: Facebook },
  { label: "TikTok", href: "https://www.tiktok.com/@NursingMoma", Icon: TikTokIcon },
  { label: "YouTube", href: "https://www.youtube.com/channel/UCfJAmR5FCofed-s_FrlOHGg", Icon: Youtube },
];

export const Footer = () => (
  <footer data-testid="footer" className="mt-24 border-t border-border/60 bg-muted/40">
    <div className="max-w-6xl mx-auto px-5 py-14 grid gap-10 md:grid-cols-3">
      <div>
        <div className="flex items-center gap-2 mb-3">
          <img src="/logo.webp" alt="Mommy's Liquid Gold logo" className="h-11 w-11 object-contain" />
          <span className="font-heading text-lg font-bold">Mommy's Liquid Gold</span>
        </div>
        <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
          Honest, warm support for breastfeeding mothers — from science-backed benefits to the
          real struggles, and the tools that make it easier.
        </p>

        <div className="mt-6">
          <h2 className="font-heading font-semibold mb-3 text-sm">Follow us on social media</h2>
          <div className="flex items-center gap-3" data-testid="footer-socials">
            {SOCIALS.map(({ label, href, Icon }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                data-testid={`social-${label.toLowerCase()}`}
                className="h-10 w-10 rounded-full bg-background border border-border flex items-center justify-center text-muted-foreground hover:text-primary-foreground hover:bg-primary hover:-translate-y-0.5 transition-all"
              >
                <Icon className="h-[18px] w-[18px]" />
              </a>
            ))}
          </div>
        </div>
      </div>
      <div>
        <h2 className="font-heading font-semibold mb-3">Explore</h2>
        <ul className="space-y-2 text-sm text-muted-foreground">
          <li><Link className="hover:text-foreground" to="/">Home</Link></li>
          <li><Link className="hover:text-foreground" to="/blog">Blog</Link></li>
          <li><Link className="hover:text-foreground" to="/best-breast-pumps">Breast Pump Types</Link></li>
          <li><Link className="hover:text-foreground" to="/pumping-tips">Pumping Tips</Link></li>
          <li><Link className="hover:text-foreground" to="/coupons">Coupons & Deals</Link></li>
          <li><Link className="hover:text-foreground" to="/giveaway">Giveaway</Link></li>
          <li><Link className="hover:text-foreground" to="/contact">Contact</Link></li>
        </ul>
      </div>
      <div>
        <h2 className="font-heading font-semibold mb-3">Good to know</h2>
        <p className="text-sm text-muted-foreground leading-relaxed">
          Some links are affiliate links. We may earn a small commission at no extra cost to you.
          Content is for informational purposes and is not medical advice.
        </p>
        <div className="mt-6">
          <h2 className="font-heading font-semibold mb-3 text-sm">Share this site</h2>
          <SiteShare align="left" />
        </div>
      </div>
    </div>
    <div className="border-t border-border/60 py-5 text-center text-xs text-muted-foreground">
      © {new Date().getFullYear()} MommysLiquidGold. Made with care for mamas everywhere.
    </div>
  </footer>
);
